import { assets } from '@/ui/assets'
import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import Image from 'next/image'
import { cn } from '@/ui/utils/style'
import { useUserPoints } from '@/features/points/logic/seasonMew/useUserPoints'
import { UserPoints } from '@/features/points/logic/types'

function formatPoints(userPoints?: UserPoints) {
  const points = userPoints?.total_amount
  if (!points) return '0'

  return points.toLocaleString(undefined, {
    maximumFractionDigits: 0,
  })
}

export function YourPoints() {
  const { data: userPoints } = useUserPoints()

  return (
    <Panel.Wrapper className="flex flex-1 flex-col gap-2 p-9">
      <div>
        <Typography variant="h2" className="text-xl" gradient>
          Your points
        </Typography>
      </div>

      <div className="flex h-16 items-center gap-2">
        <Image src={assets.hypurrPawNoShadow} alt="" width={32} height={32} className="block" />

        <Typography variant="h3" gradient gradientLayoutReset className="flex items-center gap-1 font-semibold text-4xl">
          {formatPoints(userPoints)}
        </Typography>
      </div>

      <div>
        <RowItem label="Lending" value={formatPoints(userPoints)} />
        <RowItem label="HypurrFi card" withBorder />
      </div>
    </Panel.Wrapper>
  )
}

export function RowItem({ label, value, withBorder }: { label: string; value?: string; withBorder?: boolean }) {
  return (
    <div className={cn('flex items-center justify-between gap-2 py-3', { 'border-white/4 border-t': withBorder })}>
      <Typography variant="p" className="text-sm">
        {label}
      </Typography>
      {value ? (
        <Typography variant="p" gradient className="font-bold text-sm">
          {value}
        </Typography>
      ) : (
        <div>😻</div>
      )}
    </div>
  )
}
